import { useState } from 'react';
import InnerImageZoom from 'react-inner-image-zoom';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

import { CatalogueItem } from '~/utils/types';
import styles from './product-gallery.module.scss';

// Galeria de producto (from-scratch). Cada premio tiene UNA imagen: marco
// redondeado + zoom on-hover (InnerImageZoom) + boton para ampliar (lightbox).
// La imagen es una URL absoluta (GCS), por eso el lightbox la usa tal cual.
// En un producto con variantes, `image` es la de la variante elegida.
export default function ProductGallery({
  product,
  image,
  alt: altProp,
}: {
  product: CatalogueItem;
  image?: string;
  alt?: string;
}) {
  const [isOpen, setOpen] = useState(false);
  // Sin imagen no montamos InnerImageZoom/Lightbox: ambos asumen un src valido.
  const img = image || product?.award?.mainImage;
  const alt = altProp ?? product?.award?.name ?? 'Premio';

  if (!img) {
    return (
      <div className={styles.gallery}>
        <div className={styles.frame} aria-label="Imagen no disponible" />
      </div>
    );
  }

  return (
    <div className={styles.gallery}>
      <div className={styles.frame}>
        <InnerImageZoom
          key={img}
          src={img}
          zoomSrc={img}
          zoomType="hover"
          zoomScale={1.15}
          hideHint
          className={styles.zoom}
        />
        <button
          type="button"
          className={styles.expand}
          onClick={() => setOpen(true)}
          aria-label="Ampliar imagen"
        >
          <i className="fas fa-expand"></i>
        </button>
      </div>

      <Lightbox
        open={isOpen}
        close={() => setOpen(false)}
        slides={[{ src: img, alt }]}
        render={{ buttonPrev: () => null, buttonNext: () => null }}
      />
    </div>
  );
}
